import type { Attachment, AttachmentKind } from '@/types';

const imageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result.substring(result.indexOf(',') + 1)); // strip the data:...;base64, prefix
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

/** Converts a browser File to a gateway attachment; throws for unsupported types. */
export async function fileToAttachment(file: File): Promise<Attachment> {
  let kind: AttachmentKind;
  if (imageTypes.includes(file.type)) {
    kind = 'Image';
  } else if (file.type === 'application/pdf') {
    kind = 'Document';
  } else {
    throw new Error(`'${file.name}' is not a supported attachment. Use JPEG/PNG/GIF/WebP images or PDFs — for spreadsheets and other files, use the File tasks page.`);
  }

  if (file.size > 10 * 1024 * 1024) {
    throw new Error(`'${file.name}' is ${(file.size / 1024 / 1024).toFixed(1)} MB; the limit is 10 MB per file.`);
  }

  return { kind, mediaType: file.type, fileName: file.name, data: await fileToBase64(file) };
}

/** Triggers a browser download for a base64 payload. */
export function downloadBase64(fileName: string, mediaType: string, base64: string): void {
  const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: mediaType }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
